import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Camera, Map, Home, CheckCircle, Calendar } from "react-feather";
import { Link } from "react-router-dom";

import ROUTES from "../../routes/routes";

import main_bg from "../../assets/img/tourism/main_bg.jpg";
import guide_button from "../../assets/img/tourism/guide_button.png";

import "../../assets/css/tourism.css";

export const Tourism = () => {
  return (
    <section
      id="cont-main-tourism"
      style={{
        backgroundImage: `url(${main_bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/*
        <Link to={ROUTES.EVENTS}>
          <img src={guide_button} alt="description" className="guide-button" />
        </Link> 
      */}

      <Container className="index-turism">
        <Row>
          <Col className="text-center" md="12">
            <ul id="menu-tourism">
              <Link to={ROUTES.ATRACTIVES}>
                <li style={{ backgroundColor: "#ff8a00" }}>
                  Atractivos Turísticos <Camera size={40} />
                </li>
              </Link>
              <Link to={ROUTES.TROUTES}>
                <li style={{ backgroundColor: "#ffca4e" }}>
                  Rutas <Map size={40} />
                </li>
              </Link>
              <Link to={ROUTES.SERVERS}>
                <li style={{ backgroundColor: "#00b3bd" }}>
                  Servidores Turísticos <Home size={40} />
                </li>
              </Link>
              <Link to={ROUTES.TRANSPORT}>
                <li style={{ backgroundColor: "#018281" }}>
                  Transportes <CheckCircle size={40} />
                </li>
              </Link>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
